export default {
  title: 'STAGING LOT SETTINGS',
  items: {
    SanDiegoAirportPing: {
      label: 'San Diego Airport Ping Geofence',
      type: 'integer',
      unit: 'geofence ID'
    },
    OnDeckTimeout: {
      label: 'Timeout for On Deck',
      type: 'integer',
      unit: 'seconds'
    },
    AmountOfChances: {
      label: 'Number of Chances',
      type: 'integer',
      unit: 'chances'
    },
    ActiveTimerPassengerLoading: {
      label: 'Active Timer (Passenger Loading)',
      type: 'integer',
      unit: 'minutes'
    },
    StagingOfflineMins : {
      label: 'Staging Offline Minutes',
      type: 'integer',
      unit: 'minutes'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/staging-lot-settings.js